import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { lookupName } from './utils.js';
import { getParamsKey } from '../utility/params.js';

var _excluded = ["key"];
var LOOKUP_REQUEST = "LOOKUPS/REQUEST";
var LOOKUP_RESET = "LOOKUPS/RESET";
var LOOKUP_SET = "LOOKUPS/SET";
var SAVE_LOOKUP_STATE = "LOOKUPS/SAVE";
/**
 * Action creator for requesting lookup data
 * @param {string|object} lookup A previously registered lookup or its name
 * @param {*} params Optional, parameters that will be passed to the lookup action
 * @param {object} options Additional options for the request
 * @param {number} options.key Optional, unique key for the request. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 * @param {boolean} options.cache Optional, override the lookup cache setting
 * @param {number} options.cacheExpiry Optional, override the lookup cacheExpiry setting
 * @param {number} options.cacheLimit Optional, override the lookup cacheLimit setting
 * @param {function} options.transform Optional, override the lookup transform setting
 */

var lookupRequest = function lookupRequest(lookup, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var key = options.key,
      otherOptions = _objectWithoutProperties(options, _excluded);

  return {
    type: LOOKUP_REQUEST,
    name: lookupName(lookup),
    params: params,
    key: key !== undefined ? key : getParamsKey(params),
    options: otherOptions || {}
  };
};
/**
 * Action creator for clearing cached lookup data
 * @param {string|object} lookup Optional, the lookup to reset or its name. If not specified then all lookups will be reset
 * @param {*} params Optional, parameters that were used for the lookup request to reset. If omitted (and no key is specified) then all cached data for the lookup will be cleared
 * @param {object} options Additional options for the reset
 * @param {number} options.key Optional, unique key for the lookup to reset. If omitted will be automatically generated from params, otherwise all cached data for the lookup will be cleared
 */


var lookupReset = function lookupReset(lookup, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: LOOKUP_RESET,
    name: lookup !== undefined ? lookupName(lookup) : undefined,
    params: params,
    key: options.key !== undefined ? options.key : params !== undefined && params !== null ? getParamsKey(params) : undefined
  };
};
/**
 * Action creator for manually updating cached lookup data
 * @param {string|object} lookup A previously registered lookup or its name
 * @param {*} data Data to be stored in the lookup cache
 * @param {*} params Optional, parameters that were used for the lookup request to update
 * @param {object} options Additional options for the update
 * @param {number} options.key Optional, unique key for the lookup to update. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 */


var lookupSet = function lookupSet(lookup, data, params) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var state = {
    loading: false,
    slowLoading: false,
    params: params,
    date: Date.now(),
    response: data,
    error: undefined
  };
  return {
    type: LOOKUP_SET,
    name: lookupName(lookup),
    key: options.key !== undefined ? options.key : getParamsKey(params),
    limit: undefined,
    state: state
  };
}; // internal action creators


var saveLookupState = function saveLookupState(name, key, limit) {
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    type: SAVE_LOOKUP_STATE,
    name: name,
    key: key,
    limit: limit,
    state: state
  };
};

export { LOOKUP_REQUEST, LOOKUP_RESET, LOOKUP_SET, SAVE_LOOKUP_STATE, lookupRequest, lookupReset, lookupSet, saveLookupState };
